export default __webpack_public_path__ + "static/media/marker-1-2.5871859d.png";